module.exports = __webpack_public_path__ + "static/media/160307-MobileKickoff-Recap.013.31569efa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/160307-MobileKickoff-Recap/160307-MobileKickoff-Recap.013.png
// module id = 188
// module chunks = 0